import { render, staticRenderFns } from "./article.page.pug?vue&type=template&id=6cffabae&scoped=true&lang=pug&external"
import script from "./article.page.ts?vue&type=script&lang=js&external"
export * from "./article.page.ts?vue&type=script&lang=js&external"
import style0 from "./article.page.sass?vue&type=style&index=0&id=6cffabae&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffabae",
  null
  
)

export default component.exports